import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {get, replace} from 'lodash';
import {IStickerJson} from 'src/app/diagram-data/diagram-json-handler.service';
import {GraphActionsService} from 'src/app/diagram-interaction/actions/graph-actions.service';
import {ColorPickerComponent} from 'src/app/editor-interface/shared/color-picker/color-picker.component';
import {
  additionalPaletteSticker,
  stickerCSSClassMapper,
  stickerCSSColorMapper
} from 'src/app/shared/constants/color-picker.constants';

@Component({
  selector: 'app-sticker-color-picker',
  template: `
    <app-color-picker
      class="context-bar-color"
      [color]="color"
      [palette]="palette"
      (colorPicked)="changeBackgroundColor($event)"></app-color-picker>
  `,
  styles: [
    `
      .context-bar-color {
        display: block;
        width: fit-content;
        margin: auto;
      }
    `
  ],
  standalone: true,
  imports: [ColorPickerComponent]
})
export class StickerColorPickerComponent implements OnChanges {
  @Input() stickerJson: IStickerJson;

  public color: string;

  protected palette = additionalPaletteSticker;

  constructor(private graphActionsService: GraphActionsService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.stickerJson) {
      const colorClass = this.stickerJson.paperClass;

      this.color = get(stickerCSSColorMapper, colorClass, 'FAF8E5');
    }
  }

  public changeBackgroundColor(event: string) {
    const color = replace(event, '#', '');
    const stickerCSSClass = get(stickerCSSClassMapper, color, 'FAF8E5');

    return this.graphActionsService.setStickerStyle(stickerCSSClass);
  }
}
